export default {
  payWelfareText: 'مزايا الشحن',
  blackFridayDiscount: 'تخفيضات الجمعة البيضاء المحدودة',
  shareGift: 'شارك واربح',
  vipWeeklyWelfare: 'خصم أسبوعي للـVIP',
  exchangeCoupon: 'قسيمة',
  firstPayOff: 'خصم يصل إلى 15% عند الشراء الأول',
  blackFridayEvent: 'حدث الجمعة البيضاء',
  limitedTimeOff: 'خصم 10% لفترة محدودة',
  claimCoupon: 'استلام الآن',
  blackFridayTimedCoupon: 'قسيمة الجمعة البيضاء المحدودة',
  timeLeft: 'الوقت المتبقي:',
  claimTimeCoupon: 'احصل على قسيمة خصم 10% الآن!',
  points: 'النقاط: ${point}',
  costPointTip: 'استبدل النقاط بالقسائم',
  maxPointTip: 'كل حساب يمكنه استخدام ما يصل إلى 500 نقطة.',
  discountOff: 'خصم 10%',
  highestDiscount: '${discount} خصم يصل إلى ',
  needPoint: 'يتطلب ${point} نقطة ',
  changeCurrency: 'تغيير العملة',
  claim: 'استلام',
  claimSucc: 'تم الاستلام',
  claimFail: 'فشل',
  pointNotEnough: 'النقاط غير كافية',
  afterClaimPoint: 'النقاط المتبقية: ${point}',
  footTips1: 'يمكن استخدام قسيمة واحدة فقط لكل طلبية.',
  footTips2: 'لا يمكن استخدام القسيمة لشراء عملات/رموز اللعبة.',
  footTips3: 'نحن نحتفظ بالحق في التفسير النهائي لهذا الحدث.',
  ruleTitleText: 'قواعد الحدث',
  ruleTime: 'مدة الحدث: 00:00 24 نوفمبر 2023 إلى 23:59 26 نوفمبر 2023 (UTC)',
  bfRuleText1:
    '1. سيتم منح 400 نقطة إلى حسابك عند تسجيل الدخول إلى صفحة الشحن الرسمية لأول مرة أثناء الحدث. يمكنك استبدال ما يصل إلى 500 نقطة للحصول على قسائم.',
  bfRuleText2: '2. يمكنك استبدال نقاط الجمعة البيضاء بقسائم خلال الحدث.',
  bfRuleText3:
    '3. يمكنك استخدام قسيمة واحدة فقط لكل طلبية. لا يمكن استخدام القسائم لشراء عملات/رموز اللعبة.',
  bfRuleText4: '4. بالنسبة للمعاملات، نقبل فقط العملات التالية:',
  ableCoinsType:
    'الدولار الأمريكي، الين الياباني، الوون الكوري، الدولار التايواني، اليورو، دولار هونج كونج، الجنيه الاسترليني، الدولار الكندي، الدولار الاسترالي، الروبل الروسي، الرينغيت الماليزي، بات تايلاندي، الزلوتي البولندي، الروبية الإندونيسية.',
  bfRuleText5:
    '5. لا يجوز لك تغيير العملة بمجرد إجراء المعاملة، ولا يمكن استرداد النقاط المستبدلة.',
  bfRuleText6: '6. قسائم الجمعة البيضاء صالحة لمدة 7 أيام فقط.',
  bfRuleText7: '7. نحن نحتفظ بالحق في التفسير النهائي لهذا الحدث.',
  thanksTip:
    'نشكركم على مشاركتكم. يرجى الانضمام إلى مجتمع لاعبينا الرسمي لمزيد من المعلومات حول الحدث.',
  exchangePoints: 'مبادلة',
  exchangeCode: 'أدخل رمز المبادلة.',
  enterExchangeCode: 'الرجاء إدخال رمز المبادلة.',
  exchangeText: 'مبادلة',
  confirmGet: 'تأكيد',
  couponUsedWay:
    'لا يمكن استخدام القسيمة إلا بعملات محددة، يرجى تأكيد العملة الخاصة بك.',
  confirmText: 'تأكيد',
  exchangeSucc: 'تمت المبادلة',
  aboutCoins: 'حول عملات/رموز اللعبة',
  aboutCoinsText:
    'يمكنك استبدال العملات/الرموز داخل اللعبة بجميع الحزم والامتيازات باستثناء العملات/الرموز المميزة داخل اللعبة نفسها.',
  known: 'حسنًا',
  codeText: 'رمز المبادلة',
  codeInvalid: 'رمز المبادلة غير صالح!',
  hasExchanged: 'لا يجوز لك استلام المزيد من رموز المبادلة.',
  hideText: 'إخفاء',
  //黑五的报错码
  'bf-20001': 'لم يتم تسجيل الدخول',
  'bf-20002': 'خطأ في المُعامل، يرجى محاولة إعادة دخول الحدث',
  'bf-20003': 'النقاط غير كافية',
  'bf-20004': 'فشل الاستلام، يرجى المحاولة بعد قليل أو التواصل مع خدمة العملاء',
  'bf-20005': 'تم الاستلام',
  'bf-20015': 'الحدث لم يفتح بعد، يرجى تقرب فتحه',
  'bf-20016': 'انتهى الحدث',
  bfShareText: 'احصل على قسيمة خصم 10% الآن!',
  rightsCenterBtn: 'مركز العضوية المميزة',
  payBtn: 'الدفع',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Glorious Extraordinaire (Permanent)',
  rightCenterNoticeTitle: 'حول ترقية آلية نقاط VIP إلى [مركز الفوائد]',
  rightCenterNoticeContent: 'عزيزي القائد:<br />شكرا لدعمكم المتواصل! من أجل توفير تجربة مزايا أفضل، سنقوم بتحديث شامل لآلية نقاط VIP الأصلية في 16 يوليو 2025، وإطلاق نظام "مركز العضوية المميزة" الجديد. سيعمل هذا التعديل على دمج مزايا VIP الأصلية وإضافة المزيد من المزايا. تفاصيل التعديلات كما يلي:<br />1. وصف المحتوى المُعدَّل<br />الاحتفاظ بفوائد تسجيل الدخول الأسبوعية<br />من 16 إلى 29 يوليو 2025، لا يزال بإمكان جميع اللاعبين تلقي "قسائم تخفيضات VIP الأسبوعية" عن طريق تسجيل الدخول إلى [صفحة الشحن بالموقع الرسمي]. عدد القسائم المتاحة هو نفس عدد [نشاط نقاط VIP]. في نفس الوقت، يمكن لجميع اللاعبين مبادلة قسائم جديدة في [مركز العضوية المميزة]. ستكون القسائم الموجودة في مركز الفوائد ذات حد أقصى لمبلغ التخفيض. يمكنك العثور على قواعد القسائم الجديدة وعدد القسائم التي يمكن الحصول عليها في الجدول الموجود أسفل الصفحة.<br />يرجى ملاحظة: وظيفة إصدار القسائم تلقائيًا يجب تمكينها يدويًا. مسار التمكين هو: الصفحة الرئيسية لمركز الفوائد - عرض فوائد الأعضاء - إصدار القسيمة التلقائي - انقر للتمكين - حدد القسيمة التي سيتم مبادلتها تلقائيًا - تأكيد التمكين.<br />مزايا مبادلة النقاط الجديدة<br />ستفتح وظيفة "مبادلة النقاط" بمركز الفوائد. يمكن للاعبين الحصول على نقاط من خلال المشاركة في اللعبة وتسجيل الدخول إليها، وإكمال المهام التي يحددها مركز الفوائد وغيره، واستبدالها بقسائم حصرية، وعناصر نادرة ومكافآت قيمة أخرى (انظر واجهة مركز الفوائد لمعرفة الكمية القابلة للمبادلة بالتحديد).<br />حماية الميراث على مستوى VIP<br />سيتم توريث مستوى VIP الأصلي والنقاط المتراكمة بالكامل إلى مركز الفوائد وتحويلها تلقائيًا إلى هوية مستوى مركز الفوائد المقابل. سيتم الاحتفاظ بامتيازات VIP الأصلية وتحسينها وترقيتها في نفس الوقت.<br />2. المميزات بعد التعديل<br />فوائد أكثر شفافية: يتم عرض جميع قواعد الفوائد ومحتويات المبادلة بوضوح، كما أن تجربة التجميع بنقرة واحدة غاية في الراحة.<br />مكافآت أكثر سخاءً: تتم إضافة أنشطة مبادلة نقاط جديدة، وتحديث العناصر ذات القيمة العالية من وقت لآخر.<br />فوائد اليانصيب: بالإضافة إلى مبادلة النقاط، سيكون هناك أيضًا حدث يانصيب حيث يمكنك الحصول على العناصر داخل اللعبة كمكافآت.<br />3. ملاحظات<br />خلال الفترة الانتقالية للإصدار المعدل (16 - 29 يوليو 2025)، سيتم إغلاق مدخل نقاط VIP الأصلي تدريجيًا (ولكن سيتم إصدار القسائم بشكل طبيعي قبل الإغلاق). يرجى استخدام القسائم المتبقية في الوقت المناسب. ستصبح القسائم غير المستخدمة بعد إغلاق [نشاط نقاط VIP] غير صالحة.<br />بعد إصدار مركز الفوائد، سيمكنك الدخول إليه من خلال [مركز الشحن] - [الصورة الرمزية] - دخول [مركز الفوائد].',
  rightCenterNoticeTableTitle: 'مقارنة تغييرات الكوبون ',
  rightCenterNoticeTableHeader1: 'متطلبات المبادلة - مستوى العضوية المميزة',
  rightCenterNoticeTableHeader2: 'مستوى VIP الأصلي',
  rightCenterNoticeTableHeader3: 'خصومات القسائم',
  rightCenterNoticeTableHeader4: 'قيود الحصول عليها',
  rightCenterNoticeTableHeader5: 'الحد الأقصى للتخفيض',
  rightCenterNoticeTableLevel1: 'برونزي',
  rightCenterNoticeTableLevel2: 'فضي',
  rightCenterNoticeTableLevel3: 'ذهبي',
  rightCenterNoticeTableLevel4: 'بلاتيني',
  rightCenterNoticeTableLevel5: 'ماسي',
  rightCenterNoticeTableCount1: 'مرة واحدة/اليوم',
  rightCenterNoticeTableCount2: '15 مرة/شهر',
  rightCenterNoticeTableCount3: '10 مرات/شهر',
  rightCenterNoticeTableLimit: '15 دولارًا أمريكيًا',
  rightCenterNoticeTableTip: 'يرجى الملاحظة: الحد الأقصى لتخفيض القسيمة في [مركز الفوائد] يعتمد على الدولار الأمريكي، والذي يتأثر بتقلبات سعر الصرف ويخضع لعرض صفحة الاستخدام الفعلي',
  '-': '-'
};
